import * as en from "./en-US.json";
import * as fr from "./fr-FR.json";

const languages = {
  "en-US": en,
  "fr-FR": fr,
};

export default languages;
